import React from 'react';
import {useSelector} from 'react-redux';
import {Routes, Route, Navigate} from 'react-router-dom';
import {useGetTwoFactorStatusQuery} from '@tenant/core/api/main/two-factor';
import Loader from '../../components/Loader';
import AsideLayoutFeature from '../layout/aside-layout-feature';
import TwoFactorEnrolLayoutFeature from '../layout/two-factor-enrol-layout-feature';
import publicRoutes from '../../routes/public.routes';
import useAuthenticatedRoutes from '../../hooks/use-authenticated-routes';
import {
  SLUG_ABOUT,
  SLUG_HOME,
  SLUG_LOGIN_ENROL,
} from '../../utils/constants/url';
import {checkRouteAccess} from '../../utils/helpers/routes';

const CHROMELESS_SLUGS = ['login_enrol'];

function AuthenticatedRoutesFeature() {
  const {routes: authenticated, loading} = useAuthenticatedRoutes();
  const {userVerified} = useSelector(state => state.auth);
  const {data: twoFactorStatus, isLoading: twoFactorLoading} =
    useGetTwoFactorStatusQuery();

  if (loading || twoFactorLoading) {
    return <Loader />;
  }
  const mustEnrol =
    userVerified === true &&
    Boolean(twoFactorStatus?.mandatory) &&
    !twoFactorStatus?.enabled;

  if (mustEnrol) {
    const enrolRoute = authenticated.find(r => r.slug === 'login_enrol');
    const EnrolComponent = enrolRoute?.Component;

    return (
      <Routes>
        <Route
          key="two-factor-enrol-layout"
          element={<TwoFactorEnrolLayoutFeature />}>
          {EnrolComponent && (
            <Route
              path={enrolRoute.path}
              key={enrolRoute.slug}
              element={<EnrolComponent />}
            />
          )}
          <Route
            path="*"
            element={<Navigate to={SLUG_LOGIN_ENROL} replace />}
          />
        </Route>
      </Routes>
    );
  }

  const protectedRoutes = authenticated.filter(checkRouteAccess);

  const otherRoutes = publicRoutes().filter(
    r => ![SLUG_ABOUT, SLUG_HOME].includes(r.path)
  );

  const chromeless = protectedRoutes.filter(r =>
    CHROMELESS_SLUGS.includes(r.slug)
  );

  const routes = [...protectedRoutes, ...otherRoutes].filter(
    r => !CHROMELESS_SLUGS.includes(r.slug)
  );

  return (
    <Routes>
      <Route
        key="two-factor-enrol-layout"
        element={<TwoFactorEnrolLayoutFeature />}>
        {chromeless.map(({slug, path, Component}) => (
          <Route path={path} key={slug} element={<Component />} />
        ))}
      </Route>
      <Route key="authenticated-layout" element={<AsideLayoutFeature />}>
        {routes.map(({slug, path, Component}) => (
          <Route path={path} key={slug} element={<Component />} />
        ))}
      </Route>
    </Routes>
  );
}

export default AuthenticatedRoutesFeature;
